import React from 'react';
import Tasks from '../Tasks';
import {
  Link,
  matchPath,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import {Box, Tab, TabList, Tabs} from '@chakra-ui/react';
import {TabbedPage} from '../TabbedPage';
import {Signals} from '../Debug/Signals';
import _ from 'lodash';
import {Provisioning} from '../Debug/Provisioning';
import {AiDebug} from '../Debug/AiDebug';
import {GenerateResearchPrompt} from '../Debug/GenerateResearchPrompt';
import {ValidateDomains} from '../Debug/ValidateDomains';

const adminTabs = [
  {
    label: 'Tasks',
    path: 'tasks',
  },
  {
    label: 'Provisioning',
    path: 'provisioning',
  },
  {
    label: 'Signals',
    path: 'signals',
  },
  {
    label: 'Validate Domains',
    path: 'validate-domains',
  },
  {
    label: 'AI Debug',
    path: 'ai-debug',
  },
  {
    label: 'Research Prompt',
    path: 'research-prompt',
  },
] as const;

const Admin = () => {
  const location = useLocation();
  const selectedIndex = adminTabs.findIndex((tab) =>
    matchPath(`/admin/${tab.path}/*`, location.pathname)
  );

  return (
    <TabbedPage title="Admin">
      <Tabs
        variant="line"
        index={selectedIndex}
        display="flex"
        flexDirection="column"
        flexGrow="1"
      >
        <TabList>
          {adminTabs.map(({label, path}) => (
            <Tab as={Link} key={path} to={path}>
              {label}
            </Tab>
          ))}
        </TabList>

        <Box flexGrow="1" position="relative">
          <Box position="absolute" inset="0" overflow="auto">
            <Routes>
              <Route path="/provisioning/*" element={<Provisioning />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/signals" element={<Signals />} />
              <Route path="/validate-domains" element={<ValidateDomains />} />
              <Route path="/ai-debug" element={<AiDebug />} />
              <Route
                path="/research-prompt"
                element={<GenerateResearchPrompt />}
              />
              <Route path="*" element={<Navigate to="/admin/tasks" />} />
            </Routes>
          </Box>
        </Box>
      </Tabs>
    </TabbedPage>
  );
};

export default Admin;
